import { render, staticRenderFns } from "./mediacion.vue?vue&type=template&id=8822fe40&lang=html&"
import script from "./mediacion.vue?vue&type=script&lang=js&"
export * from "./mediacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports